module.exports = __webpack_public_path__ + "background-8b0f64bd6a8393321520254138d4c42e.svg";